module.exports = __webpack_public_path__ + "static/excellence-thank-you-4dec4c140553395bf850b34493e02927.png";